/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  DeleteProjectConnectionResultDTO,
  GetShearAnchorStoreySelection200,
  HTTPValidationError,
  ProjectShearConnectionUsageDTO,
  SetShearAnchorStoreySelectionBody,
  ShearConnectionCreateDTO,
  ShearConnectionDTO,
  ShearConnectionPrioritizationDTO,
} from '../fastAPI.schemas'

/**
 * The per-storey exclusions of prioritized shear anchors.

Storeys without an entry (and anchors not listed) are in use -- the
stored state is what the user unchecked, so a newly added anchor or
storey is enabled by default.
 * @summary Get Shear Anchor Storey Selection
 */
export const getShearAnchorStoreySelection = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<GetShearAnchorStoreySelection200>({
    url: `/projects/${projectGuid}/shear-anchor-storey-selection`,
    method: 'GET',
    signal,
  })
}

export const getGetShearAnchorStoreySelectionQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/shear-anchor-storey-selection`] as const
}

export const getGetShearAnchorStoreySelectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getShearAnchorStoreySelection>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getShearAnchorStoreySelection>>,
      TError,
      TData
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetShearAnchorStoreySelectionQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShearAnchorStoreySelection>>> = ({
    signal,
  }) => getShearAnchorStoreySelection(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getShearAnchorStoreySelection>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetShearAnchorStoreySelectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShearAnchorStoreySelection>>
>
export type GetShearAnchorStoreySelectionQueryError = HTTPValidationError

/**
 * @summary Get Shear Anchor Storey Selection
 */

export function useGetShearAnchorStoreySelection<
  TData = Awaited<ReturnType<typeof getShearAnchorStoreySelection>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getShearAnchorStoreySelection>>,
      TError,
      TData
    >
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetShearAnchorStoreySelectionQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Set Shear Anchor Storey Selection
 */
export const setShearAnchorStoreySelection = (
  projectGuid: string,
  setShearAnchorStoreySelectionBody: SetShearAnchorStoreySelectionBody,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/projects/${projectGuid}/shear-anchor-storey-selection`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: setShearAnchorStoreySelectionBody,
    signal,
  })
}

export const useSetShearAnchorStoreySelectionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setShearAnchorStoreySelection>>,
    TError,
    { projectGuid: string; data: SetShearAnchorStoreySelectionBody },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setShearAnchorStoreySelection>>,
  TError,
  { projectGuid: string; data: SetShearAnchorStoreySelectionBody },
  TContext
> => {
  const mutationKey = ['setShearAnchorStoreySelection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setShearAnchorStoreySelection>>,
    { projectGuid: string; data: SetShearAnchorStoreySelectionBody }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return setShearAnchorStoreySelection(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/shear-anchor-storey-selection` },
    {
      operationId:
        'set_shear_anchor_storey_selection_projects__project_guid__shear_anchor_storey_selection_post',
      operationName: 'setShearAnchorStoreySelection',
    },
  )

  return customOptions
}

export type SetShearAnchorStoreySelectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof setShearAnchorStoreySelection>>
>
export type SetShearAnchorStoreySelectionMutationBody = SetShearAnchorStoreySelectionBody
export type SetShearAnchorStoreySelectionMutationError = HTTPValidationError

/**
 * @summary Set Shear Anchor Storey Selection
 */
export const useSetShearAnchorStoreySelection = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setShearAnchorStoreySelection>>,
    TError,
    { projectGuid: string; data: SetShearAnchorStoreySelectionBody },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setShearAnchorStoreySelection>>,
  TError,
  { projectGuid: string; data: SetShearAnchorStoreySelectionBody },
  TContext
> => {
  const mutationOptions = useSetShearAnchorStoreySelectionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Get Project Shear Connection Prioritization
 */
export const getProjectShearConnectionPrioritization = (
  projectGuid: string,
  signal?: AbortSignal,
) => {
  return customInstance<ShearConnectionPrioritizationDTO>({
    url: `/projects/${projectGuid}/shear-connection-prioritization`,
    method: 'GET',
    signal,
  })
}

export const getGetProjectShearConnectionPrioritizationQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/shear-connection-prioritization`] as const
}

export const getGetProjectShearConnectionPrioritizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectShearConnectionPrioritization>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProjectShearConnectionPrioritization>>,
      TError,
      TData
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectShearConnectionPrioritizationQueryKey(projectGuid)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProjectShearConnectionPrioritization>>
  > = ({ signal }) => getProjectShearConnectionPrioritization(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectShearConnectionPrioritization>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetProjectShearConnectionPrioritizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectShearConnectionPrioritization>>
>
export type GetProjectShearConnectionPrioritizationQueryError = HTTPValidationError

/**
 * @summary Get Project Shear Connection Prioritization
 */

export function useGetProjectShearConnectionPrioritization<
  TData = Awaited<ReturnType<typeof getProjectShearConnectionPrioritization>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProjectShearConnectionPrioritization>>,
      TError,
      TData
    >
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectShearConnectionPrioritizationQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Set Project Shear Connection Prioritization
 */
export const setProjectShearConnectionPrioritization = (
  projectGuid: string,
  shearConnectionPrioritizationDTO: ShearConnectionPrioritizationDTO,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/projects/${projectGuid}/shear-connection-prioritization`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shearConnectionPrioritizationDTO,
    signal,
  })
}

export const useSetProjectShearConnectionPrioritizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setProjectShearConnectionPrioritization>>,
    TError,
    { projectGuid: string; data: ShearConnectionPrioritizationDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setProjectShearConnectionPrioritization>>,
  TError,
  { projectGuid: string; data: ShearConnectionPrioritizationDTO },
  TContext
> => {
  const mutationKey = ['setProjectShearConnectionPrioritization']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setProjectShearConnectionPrioritization>>,
    { projectGuid: string; data: ShearConnectionPrioritizationDTO }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return setProjectShearConnectionPrioritization(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/shear-connection-prioritization` },
    {
      operationId:
        'set_project_shear_connection_prioritization_projects__project_guid__shear_connection_prioritization_post',
      operationName: 'setProjectShearConnectionPrioritization',
    },
  )

  return customOptions
}

export type SetProjectShearConnectionPrioritizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof setProjectShearConnectionPrioritization>>
>
export type SetProjectShearConnectionPrioritizationMutationBody = ShearConnectionPrioritizationDTO
export type SetProjectShearConnectionPrioritizationMutationError = HTTPValidationError

/**
 * @summary Set Project Shear Connection Prioritization
 */
export const useSetProjectShearConnectionPrioritization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setProjectShearConnectionPrioritization>>,
    TError,
    { projectGuid: string; data: ShearConnectionPrioritizationDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setProjectShearConnectionPrioritization>>,
  TError,
  { projectGuid: string; data: ShearConnectionPrioritizationDTO },
  TContext
> => {
  const mutationOptions = useSetProjectShearConnectionPrioritizationMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * How many Schubanker use each project Schubverbinder, and how many of
them are set to it by hand.
 * @summary Get Shear Connection Usage
 */
export const getShearConnectionUsage = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<ProjectShearConnectionUsageDTO[]>({
    url: `/projects/${projectGuid}/shear-connection-usage`,
    method: 'GET',
    signal,
  })
}

export const getGetShearConnectionUsageQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/shear-connection-usage`] as const
}

export const getGetShearConnectionUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getShearConnectionUsage>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getShearConnectionUsage>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetShearConnectionUsageQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShearConnectionUsage>>> = ({
    signal,
  }) => getShearConnectionUsage(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getShearConnectionUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetShearConnectionUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShearConnectionUsage>>
>
export type GetShearConnectionUsageQueryError = HTTPValidationError

/**
 * @summary Get Shear Connection Usage
 */

export function useGetShearConnectionUsage<
  TData = Awaited<ReturnType<typeof getShearConnectionUsage>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getShearConnectionUsage>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetShearConnectionUsageQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get All Project Shear Connections
 */
export const getAllProjectShearConnections = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<ShearConnectionDTO[]>({
    url: `/projects/${projectGuid}/shear-connections`,
    method: 'GET',
    signal,
  })
}

export const getGetAllProjectShearConnectionsQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/shear-connections`] as const
}

export const getGetAllProjectShearConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllProjectShearConnections>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAllProjectShearConnections>>,
      TError,
      TData
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAllProjectShearConnectionsQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProjectShearConnections>>> = ({
    signal,
  }) => getAllProjectShearConnections(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllProjectShearConnections>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetAllProjectShearConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllProjectShearConnections>>
>
export type GetAllProjectShearConnectionsQueryError = HTTPValidationError

/**
 * @summary Get All Project Shear Connections
 */

export function useGetAllProjectShearConnections<
  TData = Awaited<ReturnType<typeof getAllProjectShearConnections>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAllProjectShearConnections>>,
      TError,
      TData
    >
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllProjectShearConnectionsQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Post Add Project Shear Connection
 */
export const postAddProjectShearConnection = (
  projectGuid: string,
  shearConnectionCreateDTO: ShearConnectionCreateDTO,
  signal?: AbortSignal,
) => {
  return customInstance<ShearConnectionDTO>({
    url: `/projects/${projectGuid}/shear-connections`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shearConnectionCreateDTO,
    signal,
  })
}

export const usePostAddProjectShearConnectionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAddProjectShearConnection>>,
    TError,
    { projectGuid: string; data: ShearConnectionCreateDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAddProjectShearConnection>>,
  TError,
  { projectGuid: string; data: ShearConnectionCreateDTO },
  TContext
> => {
  const mutationKey = ['postAddProjectShearConnection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAddProjectShearConnection>>,
    { projectGuid: string; data: ShearConnectionCreateDTO }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return postAddProjectShearConnection(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/shear-connections` },
    {
      operationId:
        'post_add_project_shear_connection_projects__project_guid__shear_connections_post',
      operationName: 'postAddProjectShearConnection',
    },
  )

  return customOptions
}

export type PostAddProjectShearConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAddProjectShearConnection>>
>
export type PostAddProjectShearConnectionMutationBody = ShearConnectionCreateDTO
export type PostAddProjectShearConnectionMutationError = HTTPValidationError

/**
 * @summary Post Add Project Shear Connection
 */
export const usePostAddProjectShearConnection = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAddProjectShearConnection>>,
    TError,
    { projectGuid: string; data: ShearConnectionCreateDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof postAddProjectShearConnection>>,
  TError,
  { projectGuid: string; data: ShearConnectionCreateDTO },
  TContext
> => {
  const mutationOptions = usePostAddProjectShearConnectionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Delete a Schubverbinder; the Schubanker fixed to it by hand go back to
the priority list.
 * @summary Delete Project Shear Connection
 */
export const deleteProjectShearConnection = (projectGuid: string, connectionGuid: string) => {
  return customInstance<DeleteProjectConnectionResultDTO>({
    url: `/projects/${projectGuid}/shear-connections/${connectionGuid}`,
    method: 'DELETE',
  })
}

export const useDeleteProjectShearConnectionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectShearConnection>>,
    TError,
    { projectGuid: string; connectionGuid: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectShearConnection>>,
  TError,
  { projectGuid: string; connectionGuid: string },
  TContext
> => {
  const mutationKey = ['deleteProjectShearConnection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectShearConnection>>,
    { projectGuid: string; connectionGuid: string }
  > = props => {
    const { projectGuid, connectionGuid } = props ?? {}

    return deleteProjectShearConnection(projectGuid, connectionGuid)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/shear-connections/{connectionGuid}` },
    {
      operationId:
        'delete_project_shear_connection_projects__project_guid__shear_connections__connection_guid__delete',
      operationName: 'deleteProjectShearConnection',
    },
  )

  return customOptions
}

export type DeleteProjectShearConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProjectShearConnection>>
>

export type DeleteProjectShearConnectionMutationError = HTTPValidationError

/**
 * @summary Delete Project Shear Connection
 */
export const useDeleteProjectShearConnection = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectShearConnection>>,
    TError,
    { projectGuid: string; connectionGuid: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectShearConnection>>,
  TError,
  { projectGuid: string; connectionGuid: string },
  TContext
> => {
  const mutationOptions = useDeleteProjectShearConnectionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Post Update Project Shear Connection
 */
export const postUpdateProjectShearConnection = (
  projectGuid: string,
  connectionGuid: string,
  shearConnectionCreateDTO: ShearConnectionCreateDTO,
  signal?: AbortSignal,
) => {
  return customInstance<ShearConnectionDTO>({
    url: `/projects/${projectGuid}/shear-connections/${connectionGuid}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shearConnectionCreateDTO,
    signal,
  })
}

export const usePostUpdateProjectShearConnectionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpdateProjectShearConnection>>,
    TError,
    { projectGuid: string; connectionGuid: string; data: ShearConnectionCreateDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUpdateProjectShearConnection>>,
  TError,
  { projectGuid: string; connectionGuid: string; data: ShearConnectionCreateDTO },
  TContext
> => {
  const mutationKey = ['postUpdateProjectShearConnection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUpdateProjectShearConnection>>,
    { projectGuid: string; connectionGuid: string; data: ShearConnectionCreateDTO }
  > = props => {
    const { projectGuid, connectionGuid, data } = props ?? {}

    return postUpdateProjectShearConnection(projectGuid, connectionGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/shear-connections/{connectionGuid}` },
    {
      operationId:
        'post_update_project_shear_connection_projects__project_guid__shear_connections__connection_guid__post',
      operationName: 'postUpdateProjectShearConnection',
    },
  )

  return customOptions
}

export type PostUpdateProjectShearConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUpdateProjectShearConnection>>
>
export type PostUpdateProjectShearConnectionMutationBody = ShearConnectionCreateDTO
export type PostUpdateProjectShearConnectionMutationError = HTTPValidationError

/**
 * @summary Post Update Project Shear Connection
 */
export const usePostUpdateProjectShearConnection = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpdateProjectShearConnection>>,
    TError,
    { projectGuid: string; connectionGuid: string; data: ShearConnectionCreateDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof postUpdateProjectShearConnection>>,
  TError,
  { projectGuid: string; connectionGuid: string; data: ShearConnectionCreateDTO },
  TContext
> => {
  const mutationOptions = usePostUpdateProjectShearConnectionMutationOptions(options)

  return useMutation(mutationOptions)
}
